import { Clock, Pill, Zap } from "lucide-react";

import { BarChartCard } from "./BarChartCard";
import { formatCount } from "./chartPalette";
import { ChartsGrid, InsightsPanel, StatsRow } from "./InsightsLayout";
import { StatCard } from "./StatCard";
import { TrendChartCard } from "./TrendChartCard";

export const PrescriptionsInsights = ({ insights, isLoading }) => {
  return (
    <InsightsPanel>
      <StatsRow>
        <StatCard label="Total Prescriptions" icon={Pill} isLoading={isLoading}
          value={formatCount(insights?.totalPrescriptions)} />
        <StatCard label="Long Term" icon={Clock} isLoading={isLoading}
          value={formatCount(insights?.longTermCount)} />
        <StatCard label="Acute" icon={Zap} isLoading={isLoading}
          value={formatCount(insights?.acuteCount)} />
      </StatsRow>
      <ChartsGrid>
        <BarChartCard title="Top Medications" data={insights?.byDrug} isLoading={isLoading} />
        <BarChartCard title="By Pharmacy" data={insights?.byPharmacy} isLoading={isLoading} />
        <TrendChartCard title="Prescriptions Over Time" data={insights?.trendByDay} isLoading={isLoading} />
      </ChartsGrid>
    </InsightsPanel>
  );
};
